__turbopack_context__.v({
  "copyControl": "uwUeQW_copyControl",
  "page": "uwUeQW_page",
  "row": "uwUeQW_row",
  "section": "uwUeQW_section",
  "term": "uwUeQW_term",
  "value": "uwUeQW_value",
  "valueText": "uwUeQW_valueText",
});
